export const DEFAULT_INTERFACE_PREFERENCES = Object.freeze({
  shell: 'legacy',
  themeMode: 'system'
});

const SHELLS = ['legacy', 'modern'];
const THEME_MODES = ['light', 'dark', 'system'];

export function normalizeInterfacePreferences(payload = {}) {
  const data = payload && payload.data && typeof payload.data === 'object' ? payload.data : {};

  return {
    shell: SHELLS.includes(data.shell) ? data.shell : DEFAULT_INTERFACE_PREFERENCES.shell,
    themeMode: THEME_MODES.includes(data.theme_mode) ? data.theme_mode : DEFAULT_INTERFACE_PREFERENCES.themeMode,
    shellSource: payload && payload.meta && payload.meta.shell_source === 'explicit' ? 'explicit' : 'default'
  };
}

export function serializePreferencePatch(patch = {}) {
  const payload = {};

  if (Object.prototype.hasOwnProperty.call(patch, 'shell')) {
    if (!SHELLS.includes(patch.shell)) throw new TypeError('Invalid shell preference');
    payload.shell = patch.shell;
  }
  if (Object.prototype.hasOwnProperty.call(patch, 'themeMode')) {
    if (!THEME_MODES.includes(patch.themeMode)) throw new TypeError('Invalid theme preference');
    payload.theme_mode = patch.themeMode;
  }
  if (!Object.keys(payload).length) throw new TypeError('No supported preference supplied');

  return payload;
}

export function defaultRouteForInterfacePreferences(preferences = DEFAULT_INTERFACE_PREFERENCES) {
  return preferences.shell === 'modern' ? '/app/graficador-next' : '/app/graficador-dinamico';
}
